export const userEmail = 'janedoe@example.com';
export const userFirstName = 'Jane';
export const userLastName = 'Doe';
export const userInfo = {
    sub: '81020509-159b-4a05-a4ec-1b65bf47fc87',
    firstName: 'Jane',
    lastName: 'Doe',
    name: 'Jane Doe',
    email: userEmail,
    phoneNumber: '+3530861253888',
    isPhoneVerified: false,
    picture: 'https://identity-ts.id.yadkrow.com/oauth2/v1/userImage',
    locale: 'en',
    accountResetDate: '2027-02-22T22:22:22Z'
};

export const userInfoWithoutLocale = {
    sub: '81020509-159b-4a05-a4ec-1b65bf47fc87',
    firstName: 'Jane',
    lastName: 'Doe',
    name: 'Jane Doe',
    email: userEmail,
    phoneNumber: '+3530861253888',
    isPhoneVerified: false,
    picture: 'https://identity-ts.id.yadkrow.com/oauth2/v1/userImage',
    accountResetDate: '2027-02-22T22:22:22Z'
};

export const userSettings = {
    emailPreferences: { enableProvisioning: false }
};

export const availableLocales = {
    locales: [
        {
            languageTag: 'en-us',
            displayString: 'English, United States'
        },
        {
            languageTag: 'en-nz',
            displayString: 'English, New Zealand'
        },
        {
            languageTag: 'en',
            displayString: 'English'
        },
        {
            languageTag: 'rv',
            displayString: 'Reverse English'
        }
    ]
};

export const userLocale = {
    languageTag: 'en-us'
};

export const userId = '123';

export const userSessions = {
    sessionDetails: [
        {
            id: '047a6fbb-9785-4570-ae19-03f2d473a85f',
            ipAddress: '127.0.0.1',
            accessType: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:100.0) Gecko/20100101 Firefox/100.0',
            creationTime: '1652958596',
            lastAccessedTime: '1652958600'
        },
        {
            id: '79238eb7-32ee-4736-a36f-fd35da063070',
            ipAddress: '0:0:0:0:0:0:0:1',
            accessType:
                'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/101.0.4951.64 Safari/537.36',
            creationTime: '1652955987',
            lastAccessedTime: '1652958622'
        },
        {
            id: 'e7355bb5-5aae-4048-a78b-970d0f1f81b2',
            ipAddress: '127.0.0.1',
            accessType: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:100.0) Gecko/20100101 Firefox/100.0',
            creationTime: '1652958576',
            lastAccessedTime: '1652958581'
        }
    ]
};
